<div class="container">
  @if (paxConnections$ | async; as paxConnections) {
    @if (
      paxConnections.response &&
      paxConnections.response.connections.length === 0
    ) {
      <div class="text-base p-32 flex-center">None</div>
      <div class="text-xs opacity-6 flex-center">
        Data may not be available until ~24 hours prior.
      </div>
    } @else if (paxConnections.isLoading && !paxConnections.response) {
      <div class="loading-container">
        <mat-spinner color="accent" [diameter]="32"></mat-spinner>
      </div>
    } @else {
      <app-data-box headerTitle="" class="mt-32 mb-24 width-100">
        <mat-radio-group class="flex-around" [(ngModel)]="filter">
          <mat-radio-button color="accent" value="all" name="filter"
            >All</mat-radio-button
          >
          <mat-radio-button color="accent" value="caution" name="filter">
            <span class="caution-color font-medium">&lt; 45 min</span>
          </mat-radio-button>
          <mat-radio-button color="accent" value="warning" name="filter">
            <span class="warn-color font-medium">&lt; 20 min</span>
          </mat-radio-button>
        </mat-radio-group>
      </app-data-box>
      @for (
        connection of paxConnections.response?.connections;
        track connection.destCity + connection.flight
      ) {
        @if (
          filter() === "all" ||
          (filter() === "caution" &&
            connection.delta &&
            connection.delta.as("minutes") < 45) ||
          (filter() === "warning" &&
            connection.delta &&
            connection.delta.as("minutes") < 20)
        ) {
          <div class="conn-container thin-gray-border">
            <div class="row">
              <div class="col flex-start">
                <div>{{ connection.destCity }}, {{ connection.destState }}</div>
                <div class="flight">
                  <img src="assets/AA.png" width="20px" height="20px" />
                  <div>{{ connection.flight }}</div>
                </div>
              </div>
              <div class="col">
                <div class="text-base">
                  {{ connection.depTime?.toFormat("HH:mm") }}
                </div>
                <div class="text-sm opacity-6">
                  {{ connection.gate }}
                </div>
              </div>
              <div class="col flex-end">
                <div
                  class="text-base"
                  [class.success-color]="
                    connection.delta && connection.delta.as('minutes') >= 45
                  "
                  [class.caution-color]="
                    connection.delta &&
                    connection.delta.as('minutes') < 45 &&
                    connection.delta.as('minutes') >= 20
                  "
                  [class.warn-color]="
                    connection.delta && connection.delta.as('minutes') < 20
                  "
                >
                  {{ connection.delta | duration }}
                </div>
              </div>
            </div>
          </div>
        }
      }
    }
    <div class="data-status">
      <app-data-status
        [isLoading]="paxConnections.isLoading"
        [timestamp]="paxConnections.response?.timestamp"
        (refresh)="refresh()"
      ></app-data-status>
    </div>
    @if (paxConnections.isLoading) {
      <mat-progress-bar
        class="progress-bar-bottom"
        color="accent"
        mode="indeterminate"
      ></mat-progress-bar>
    }
  }
</div>
